<template>
  <div id="app">
    <div class="sidebar">
      <a href="https://zhih.me" title="zhih.me" class="logo">
        <img alt="logo" src="//pic.zhih.me/blog/favicon.png">
      </a>
      <div class="sidebar-wapper">
        <template v-for="(menu, index) in sidebar">
          <router-link :to="menu.link" :title="menu.name" class="menu" :key="index">
            <div class="menu-cursor" v-html="menu.icon"></div>
            <span>{{ menu.name }}</span>
          </router-link>
        </template>
      </div>
    </div>
    <router-view :pageData="pageData"></router-view>
  </div>
</template>

<script>

  import icons from './static/icons/icon.json'
  import json from '../../all-data/json/all.json'

  export default {
    name: 'App',
    data () {
      return {
        sidebar: icons,
        pageData: []
      }
    },
    created () {
      let that = this
      that.pageData = json
      // let api = '/hackintosh/all.json'
      // let api = 'https://pic.zhih.me/hackintosh/all.json'
      // this.axios
      // .get(api)
      // .then((response) => {
      //   that.pageData = response.data
      // })
    }
  }
</script>

<style src="./assets/main.css"></style>
